import axios from "axios"
import { onMounted, ref, watch } from "vue"
import Directr from '@/services/directr'
import { useStore } from "vuex"
import { $castArray } from "@/utils"

export default function useDocParser () {
  const $store = useStore()
  const $directr: Directr = $store.getters['Services/Directr']

  const showingDocs = ref(false)
    const docData = ref<Array<string>>()
    async function showDocuments (values: Array<string>) {
      try {
        docData.value = await Promise.all(values.map(doc => {
          // NOTE: pdf docs have consistent starting character values, and as such the base64 string always starts with the same sequence "JVBER"
          if (typeof doc === 'string' && ((doc.startsWith('^XA') && doc.endsWith('^XZ')) || !doc.startsWith('JVBER'))) return ConvertZpltoPdfBase64(doc)

          return doc
        })).then(d => d.flat(1))
        showingDocs.value = true
      } catch (e) {
        console.error('showDocuments error', e)
        showingDocs.value = false
      }
    }

    async function ConvertZpltoPdfBase64 (zplDataString: string) {
    const converted: Array<string> = (await $directr.post('labels.convert.zpl', ['zpl'], { labels: $castArray(zplDataString) })).items || []

    return converted
  }

  watch(() => showingDocs.value, val => {
    if (!val) docData.value = undefined
  })

  // onMounted(() => { /* **/ })

  return {
    ConvertZpltoPdfBase64,
    showDocuments,
    showingDocs,
    docData
  }
}
